import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import { CustomModalAnimated } from '../modal-animated';

interface IProps {
  open: boolean;
  handleClose: () => void;
}

export const ClaimAccountModal = ({ open, handleClose }: IProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClick = () => {
    window.open('https://www.trackgood.io/contact', '_blank');
  };

  return (
    <CustomModalAnimated
      showCloseButton
      ariaLable={`claim-account`}
      open={open}
      handleClose={handleClose}
      sx={{ maxWidth: '400px', width: '90dvw', height: 'fit-content' }}>
      
      <Box id="claim-account-modal__components-claim-account__box__l25"
      sx={{
        boxSizing: 'border-box',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        p: '80px 20px 35px',
        gap: '45px'
      }}>
        
        <Typography id="claim-account-modal__components-claim-account__typography__l37" fontSize={'14px'} textAlign={'center'}>
          Is this your business? Claim this account to manage and update your details. Contact us
          below to verify ownership.
        </Typography>
        <Button id="claim-account-modal__components-claim-account__button__l41"
        variant="outlined"
        size={isMobile ? 'small' : 'medium'}
        sx={{
          color: theme.palette.primary.main,
          textTransform: 'uppercase',
          borderRadius: '10px'
        }}
        onClick={handleClick}>
          
          Get in contact
        </Button>
      </Box>
    </CustomModalAnimated>);

};